import api from './api';

/**
 * سرویس مدیریت مراجعان
 * شامل CRUD عملیات برای مراجعان
 */

// دریافت لیست مراجعان با pagination و جستجو
export const getClients = async (params = {}) => {
  try {
    const response = await api.get('/clients', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت اطلاعات یک مراجع خاص
export const getClientById = async (clientId) => {
  try {
    const response = await api.get(`/clients/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// ایجاد مراجع جدید (فقط برای مدیران)
export const createClient = async (clientData) => {
  try {
    const response = await api.post('/clients', clientData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// بروزرسانی اطلاعات مراجع (فقط برای مشاوران)
export const updateClient = async (clientId, clientData) => {
  try {
    const response = await api.put(`/clients/${clientId}`, clientData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// حذف مراجع (soft delete - فقط برای مدیران)
export const deleteClient = async (clientId) => {
  try {
    const response = await api.delete(`/clients/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// جستجو در مراجعان
export const searchClients = async (searchTerm) => {
  try {
    const response = await api.get('/clients', {
      params: { 
        search: searchTerm,
        limit: 100 // برای جستجو، تعداد بیشتری از نتایج را دریافت کن
      }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// دریافت مراجعان مشاور فعلی
export const getMyClients = async (params = {}) => {
  try {
    const response = await api.get('/clients/my', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}; 